import { render, staticRenderFns } from "./AcaoSocialPublico.vue?vue&type=template&id=096d7582&scoped=true"
import script from "./AcaoSocialPublico.vue?vue&type=script&lang=js"
export * from "./AcaoSocialPublico.vue?vue&type=script&lang=js"
import style0 from "./AcaoSocialPublico.vue?vue&type=style&index=0&id=096d7582&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096d7582",
  null
  
)

export default component.exports